import { all } from 'redux-saga/effects';
import { onClearAgent, onLoginAgent, onLogoutAgent, onPerformFetchAgent } from '@state/agent/agentOperations';

export function* combinedAgentSagas() {
  yield all([onPerformFetchAgent(), onLoginAgent(), onLogoutAgent(), onClearAgent()]);
}
